module.exports = __webpack_public_path__ + "static/media/map-pin.e9e52fce.svg";